<script lang="ts" setup>
import TtAccordion from '@/components/TtAccordion.vue'
import IconParking from '@/components/Icon/ParkingPaid.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({ useScope: 'global' })
</script>

<template>
  <div class="mx-5 mb-5 border-b border-black/10 pb-5">
    <TtAccordion>
      <template v-slot:accordionButton>
        <div class="flex w-full items-center justify-between font-light">
          <div>
            <h2 class="text-lg font-semibold leading-9 tracking-tight">
              {{ t('filter.places.parkings') }}
            </h2>
          </div>
          <div class="flex items-center gap-2 text-lg tracking-tight">
            <IconParking />
          </div>
        </div>
      </template>
      <div class="pt-3">
        <div class="grid gap-1.5">
          <div
            :class="`flex w-full items-center justify-between rounded border border-black/10 disabled:border-tt-lighter-gray disabled:bg-tt-lighter-gray`"
            v-for="i in [11324, 12232]"
            :key="i"
          >
            <div class="flex h-[52px] items-center gap-2">
              <IconParking class="m-3 mr-0" />
              <div class="relative">
                <div class="flex items-center gap-2">
                  <span class="">#{{i}}</span>
                  <div class="h-2 w-2 rounded-full bg-tt-green"></div>
                </div>
              </div>
            </div>
            <div>
              <div
                :class="`mr-4 flex items-center gap-1 font-mono tracking-tighter`"
              >
                <span class="">100</span>
                <span class="text-tt-gray/50">kr</span>
                <svg
                  class="ml-1"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="12"
                  fill="none"
                  viewBox="0 0 16 12"
                >
                  <path
                    fill="currentColor"
                    d="M15.5 1.5A1.5 1.5 0 0 0 14 0H2A1.5 1.5 0 0 0 .5 1.5v9A1.5 1.5 0 0 0 2 12h12a1.5 1.5 0 0 0 1.5-1.5v-9ZM14 3H2V1.5h12V3ZM2 5.25h12v5.25H2V5.25Z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </TtAccordion>
  </div>
</template>
